import { useEffect, useRef } from 'react';
import { CustomPicker } from '@hotmart/space-lib/dist/components/customPicker';

import { useUser } from 'src/hook/useUser';
import { useI18n } from '../hooks/useI18n';
import { ContainerPicker } from './emojiPicker.styles';
import { EmojiPickerProps } from './emojiPicker.types';

const EmojiPicker = ({ isOpen, close, handleSelectEmoji }: EmojiPickerProps) => {
  const i18n = useI18n();
  const { theme } = useUser();
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click,', handleClick, true);
    };
  }, []);

  return (
    <div className="_position-relative">
      {isOpen && (
        <ContainerPicker className="_position-absolute" ref={ref} data-test="emoji-picker">
          <CustomPicker onEmojiSelect={handleSelectEmoji} theme={theme} i18n={i18n} />
        </ContainerPicker>
      )}
    </div>
  );
};

export default EmojiPicker;
